import axios from "../plugins/parseAxios";
export class QuotaionAPI {

  static getQuotation(quotaionId) {
    return axios.post("functions/getQuotation", {
      id: quotaionId
    });
  }
  static createQuotation(postData) {
    return axios.post("functions/createQuotation", postData);
  }
  static updateQuotation(postData) {
    return axios.post("functions/updateQuotation", postData);
  }
  static sendQuotation({id, date, dueDate}) {
    return axios.post("functions/sendQuotation", {
      id,
      date,
      dueDate
    });
  }
  static unsendQuotation(quotaionId) {
    return axios.post("functions/unsendQuotation", {
      id: quotaionId
    });
  }
}
